import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * Service de cong�s
 */
@Injectable({
    providedIn: 'root'
})
export class CongesService {

    /**
     * Constructeur
     * @param http
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Lister les cong�s
     */
    listerConges(codeFournisseur: string) {
        let httpParams = new HttpParams().set('Code', codeFournisseur);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/conges/listercongesfast`, options).pipe(map((retour: any): any => { return retour }));
    }

    /**
     * Valider la non prise de cong�s durant les prochaines f�tes / �t�s
     */
    validateHollidays(codeFournisseur: string, codePays: string) {
        let httpParams = new HttpParams().set('CodeFournisseur', codeFournisseur).set('CodePays', codePays);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/conges/validatehollidays`, options).pipe(map((retour: any): any => { return retour }));
    }

    /**
     * Est-ce que le PR a valid� ses cong�s
     */
    getIsValidHollidays(codeFournisseur: string, codePays: string) {
        let httpParams = new HttpParams().set('CodeFournisseur', codeFournisseur).set('CodePays', codePays);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/conges/isvalidhollidays`, options).pipe(map((retour: any): any => { return retour }));
    }

    /**
     * Saisir les cong�s
     */
    saisirConges(codeFournisseur: string, dateDebut: Date, dateFin: Date, commentaire: string, codeType: string) {
        let modele = {
            Conges: {
                DateDebut: dateDebut.toJSON(),
                DateFin: dateFin.toJSON(),
                Commentaire: commentaire,
                CodeTypeConges: codeType,
                CodeFournisseur: codeFournisseur,
            }
        };
        return this.http.post(`api/conges/saisircongesfast`, modele).pipe(map((retour: any): any => { return retour }));
    }

    /**
     * Supprimer les cong�s
     */
    supprimerConges(codeFournisseur: string, dateDebut: Date, dateFin: Date, codeType: string, idCalendrierFermeture: string) {
        let modele = {
            Conges: {
                DateDebut: dateDebut.toJSON(),
                DateFin: dateFin.toJSON(),
                CodeTypeConges: codeType,
                CodeFournisseur: codeFournisseur,
                IdCalendrierFermeture: idCalendrierFermeture
            }
        };
        return this.http.post(`api/conges/supprimercongesfast`, modele).pipe(map((retour: any): any => { return retour }));
    }
}
